import React from 'react';
import {Button, Grid, Typography} from '@material-ui/core';
import CodeMirror from '@uiw/react-codemirror';
import {langs} from '@uiw/codemirror-extensions-langs';
import {vscodeDark} from '@uiw/codemirror-theme-vscode';

type PreviewYamlStepProps = {
  yaml: string;
  hasPermission: boolean;
  onChange: (yaml: string) => void;
  onBack: () => void;
  onNext: () => void;
};

export const PreviewYamlStep = ({
  yaml,
  hasPermission,
  onChange,
  onBack,
  onNext,
}: PreviewYamlStepProps) => (
  <Grid container spacing={2}>
    <Grid item xs={12}>
      <Typography variant='body1'>
        This is the catalog-info.yaml that will be added to your repository, generated from what you
        entered. You can edit it directly below before continuing.
      </Typography>
    </Grid>
    <Grid item xs={12}>
      <CodeMirror
        value={yaml}
        height='100%'
        maxHeight='500px'
        onChange={onChange}
        theme={vscodeDark}
        extensions={[langs.yaml()]}
        lang='yaml'
      />
    </Grid>
    <Grid item xs={12}>
      <Button onClick={onBack}>Back</Button>
      <Button variant='contained' color='primary' onClick={onNext} style={{marginLeft: 8}}>
        {hasPermission ? 'Open a PR for Registration' : 'Next'}
      </Button>
    </Grid>
  </Grid>
);
